// extracted by mini-css-extract-plugin
module.exports = {"contextMenu":"groups-menu_contextMenu_3nlxD","link":"groups-menu_link_2K33v","label":"groups-menu_label_wWuBT"};